import { render, staticRenderFns } from "./SelectPosition.vue?vue&type=template&id=2498af26&"
import script from "./SelectPosition.vue?vue&type=script&lang=js&"
export * from "./SelectPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports